export const PARAMS = {
  ID: "id",
  DUPLICATE_ID: "duplicateId",
  SUB_TYPE: "subType"
}
export const VALUES_PARAMS = {
  NEW_ENTITY: "new"
}

export const NAMES_ROUTES = {
  GOVERNANCE: {
    ROOT: "governance",
    AI: "ai",
    SCM: "scm",
    CI: "ci",
    CI_SCA: "ci-sca",
    CI_SAST: "ci-sast",
    CODE: "code",
    SCAN_HISTORY: "scan-history",
    AUTOMATION_POLICIES: "automation-policies",
    THREAT_DETECTION_POLICIES: "threat-detection",
    WORKFLOWS: "workflows",
    POLICIES: {
      PROTECT: "protect",
      SUPPRESS: "suppress"
    }
  },
  SETTINGS: {
    ROOT: "settings",
    SCOPES: "scopes",
    KAI: {
      ROOT: "kai",
      GUIDANCE: "guidance"
    }
  },
  POLICY_EXCEPTION: {
    ROOT: "policy-exception"
  },
  SIGN_IN: {
    ROOT: "signin"
  },
  // Not "scm/signin": it would shadow the ":slug/signin" page of a tenant named "scm".
  SCM_SIGN_IN: {
    ROOT: "scm",
    START: "start",
    CALLBACK: "callback"
  },
  INTEGRATIONS: {
    ROOT: "integrations",
    CALLBACK: "callback"
  },
  DISCOVERY: {
    ROOT: "discovery",
    BRANCH: "branch",
    APPLICATIONS: "applications",
    IMAGES: "images",
    BASE_IMAGES: "baseImages",
    SBOM: "sbom",
    VM: "vm",
    API: "api",
    AI_DISCOVERY: "ai-discovery"
  },
  TRIAGE: {
    ROOT: "triage",
    ISSUES: "issues",
    INCIDENTS: "incidents"
  },
  DEPLOYMENTS: {
    ROOT: "deployments",
    NEW_DEPLOYMENT: "new-deployment"
  },
  REPORTS: {
    ROOT: "reports",
    RECURRING: "recurring",
    WAREHOUSE: "warehouse"
  }
}

export const OVERVIEW_PATH = "/"

/** Kodem's own sites - anything served from here is ours, not an external source. */
export const KODEM_HOST = "kodemsecurity.com"

export const EXTERNAL_ROUTES = {
  API_DOCS: `https://docs.${KODEM_HOST}`,
  PUBLIC_DOCS: `https://public.${KODEM_HOST}/docs`,
  CLI_AUTH: "/cli-auth",
  MCP_AUTH: "/mcp-auth",
  PARAMS: {
    JWT_TOKEN: "jwt_token"
  }
}

export const INTEGRATION_TAGS = {
  continuousIntegration: "Continuous Integration",
  sourceControl: "Source control",
  aiAgents: "AI Agents"
}
